<template>
    <div style="position: relative;">
        <transition name="drop-fade">
            <TopBar :swich="isSwich" @sendSwich="sendSwichTopBar" v-show="!isVisible || isSwich" />
        </transition>
        <div v-show="isSwich" class="detail_pop_box">
            <DetailPage />
        </div>
        <div id="mainPage">
            <MainPage @showBar="onShowBar" @swichUse="onSwichUse" />
        </div>

        <!-- <keep-alive>
            <component @showBar="onShowBar" @swichUse="onSwichUse" :is="pages[currentPage]" />
        </keep-alive> -->

    </div>

</template>


<script setup>
import { ref } from "vue";
import TopBar from "./components/TopBar.vue";
import MainPage from "./MainPage.vue";
import DetailPage from "./components/DetailPage.vue";





const isSwich = ref(false);

const isVisible = ref(true); //顶部bar按钮

const onShowBar = (value) => {
    isVisible.value = value;
}

const onSwichUse = (value) => {
    console.log(value);
    isSwich.value = true;
    document.body.style.overflow = "hidden";

}

const sendSwichTopBar = (value) => {
    isSwich.value = !value;
    document.body.style.overflow = value ? "" : "hidden";

}





</script>

<style>
html,
body {
    margin: 0;
    padding: 0;
}


/* body {
    overflow: hidden;
} */

#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    color: white;
    background-color: rgba(96, 34, 131, 0.6);
}

body::-webkit-scrollbar {
    display: none;
}

.detail_pop_box::-webkit-scrollbar {
    display: none;
}


/* 显示前状态 */
.drop-fade-enter-from,
.drop-fade-leave-to {
    opacity: 0;
    transform: translate(-60px) scale(0.8);
}

/* 显示后状态 */
.drop-fade-enter-to,
.drop-fade-leave-from {
    opacity: 1;
    transform: translateY(0) scale(1);
}

/* 过渡时间 */
.drop-fade-enter-active,
.drop-fade-leave-active {
    transition: all 1s ease;
}


.detail_pop_box {
    position: fixed;
    z-index: 999;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100vh;
    overflow: auto;
    background-color: #9C76B1;
}
</style>